module.exports = __webpack_public_path__ + "media/images/favicon-8c8e633cc5dc3aa48ad33b34daf4934f.png";